import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import LayoutContainer from '../../../Components/Layouts';
import { childrenType } from '../../../Type';
import ErrorPage from '../../Public/ErrorPage';

const BrowserRouterProvider:React.FC<childrenType> = ({ children} ) => {
    return (
        <BrowserRouter>
            <Routes>
                <Route element={<LayoutContainer />}>
                    {children}
                    <Route path='*' element={<ErrorPage/>} />
                </Route>
            </Routes>
        </BrowserRouter>
    )
}

export default BrowserRouterProvider